import {
  ADD_LEI_ISSUER,
  SET_ASSOCIATED_ENTITY,
  SET_BRANCHES,
  SET_DIRECT_CHILDREN,
  SET_DIRECT_CHILD_RELATIONSHIPS,
  SET_DIRECT_PARENT,
  SET_DIRECT_PARENT_RELATIONSHIP,
  SET_DIRECT_PARENT_REPORTING_EXCEPTION,
  SET_FEEDER_FUNDS,
  SET_FUND_MANAGER,
  SET_FUND_MANAGER_RELATIONSHIP_DATA,
  SET_HEAD_OFFICE,
  SET_HEAD_OFFICE_RELATIONSHIP_DATA,
  SET_MANAGED_FUNDS,
  SET_MASTER_FUND,
  SET_MASTER_FUND_RELATIONSHIP_DATA,
  SET_SUB_FUNDS,
  SET_SUCCESSOR_ENTITIES,
  SET_SUCCESSOR_ENTITY,
  SET_ULTIMATE_CHILDREN,
  SET_ULTIMATE_CHILD_RELATIONSHIPS,
  SET_ULTIMATE_PARENT,
  SET_ULTIMATE_PARENT_RELATIONSHIP,
  SET_ULTIMATE_PARENT_REPORTING_EXCEPTION,
  SET_UMBRELLA_FUND,
  SET_UMBRELLA_FUND_RELATIONSHIP_DATA,
} from '../mutations-types'

export const mutationsResolver = {
  'ultimate-children': SET_ULTIMATE_CHILDREN,
  'ultimate-parent': SET_ULTIMATE_PARENT,
  'ultimate-parent-relationship': SET_ULTIMATE_PARENT_RELATIONSHIP,
  'ultimate-child-relationships': SET_ULTIMATE_CHILD_RELATIONSHIPS,
  'ultimate-parent-reporting-exception': SET_ULTIMATE_PARENT_REPORTING_EXCEPTION,
  'direct-child-relationships': SET_DIRECT_CHILD_RELATIONSHIPS,
  'direct-children': SET_DIRECT_CHILDREN,
  'direct-parent': SET_DIRECT_PARENT,
  'direct-parent-relationship': SET_DIRECT_PARENT_RELATIONSHIP,
  'direct-parent-reporting-exception': SET_DIRECT_PARENT_REPORTING_EXCEPTION,
  'lei-issuer': ADD_LEI_ISSUER,
  'successor-entity': SET_SUCCESSOR_ENTITY,
  'associated-entity': SET_ASSOCIATED_ENTITY,
  'head-office': SET_HEAD_OFFICE,
  'branches': SET_BRANCHES,
  'fund-manager': SET_FUND_MANAGER,
  'managed-funds': SET_MANAGED_FUNDS,
  'umbrella-fund': SET_UMBRELLA_FUND,
  'sub-funds': SET_SUB_FUNDS,
  'master-fund': SET_MASTER_FUND,
  'feeder-funds': SET_FEEDER_FUNDS,
  'successor-entities': SET_SUCCESSOR_ENTITIES,
  'head-office-relationship': SET_HEAD_OFFICE_RELATIONSHIP_DATA,
  'fund-manager-relationship': SET_FUND_MANAGER_RELATIONSHIP_DATA,
  'master-fund-relationship': SET_MASTER_FUND_RELATIONSHIP_DATA,
  'umbrella-fund-relationship': SET_UMBRELLA_FUND_RELATIONSHIP_DATA,
}

const actions = [
  {
    items: [ 'direct-parent', 'ultimate-parent', ],
    isExist: (r, t) => r[t] ? !!r[t].links['lei-record'] : false,
  },
  {
    items: [ 'lei-issuer', ],
    isExist: (r, t) => !!r[t],
  },
  {
    items: [ 'direct-parent-relationship', 'ultimate-parent-relationship', ],
    isExist: (r, t) => {
      const field = t === 'direct-parent-relationship' ? 'direct-parent' : 'ultimate-parent'
      return r[field] ? !!r[field].links['relationship-record'] : false
    },
  },
  {
    items: [ 'direct-parent-reporting-exception', 'ultimate-parent-reporting-exception', ],
    isExist: (r, t) => {
      const field = t === 'direct-parent-reporting-exception' ? 'direct-parent' : 'ultimate-parent'
      return r[field] ? !!r[field].links['reporting-exception'] : false
    },
  },
  {
    items: [ 'direct-children', 'ultimate-children', ],
    isExist: (r, t) => !!r[t],
  },
  {
    items: [ 'direct-child-relationships', 'ultimate-child-relationships', ],
    isExist: (r, t) => {
      const field = t === 'direct-child-relationships' ? 'direct-children' : 'ultimate-children'
      return r[field] ? !!r[field].links['relationship-records'] : false
    },
  },
  {
    items: [ 'head-office', 'branches', ],
    isExist: (r, t) => !!r[t],
  },
  {
    items: [ 'fund-manager', 'managed-funds', ],
    isExist: (r, t) => !!r[t],
  },
  {
    items: [ 'umbrella-fund', 'sub-funds', ],
    isExist: (r, t) => !!r[t],
  },
  {
    items: [ 'master-fund', 'feeder-funds', ],
    isExist: (r, t) => !!r[t],
  },
  {
    items: [
      'head-office-relationship',
      'fund-manager-relationship',
      'master-fund-relationship',
      'umbrella-fund-relationship',
    ],
    isExist: (r, t) => {
      if (t === 'head-office-relationship') return r['head-office'] ? !!r['head-office'].links['relationship-record'] : false
      if (t === 'fund-manager-relationship') return r['fund-manager'] ? !!r['fund-manager'].links['relationship-record'] : false
      if (t === 'master-fund-relationship') return r['master-fund'] ? !!r['master-fund'].links['relationship-record'] : false
      if (t === 'umbrella-fund-relationship') return r['umbrella-fund'] ? !!r['umbrella-fund'].links['relationship-record'] : false
    },
  },
]

const getDispatches = (id, relationships, dispatch, { items, isExist, }) => {
  const existed = (items) => (
    items.reduce((acc, type) => isExist(relationships, type) ? [ ...acc, type, ] : [ ...acc, ], [])
  )
  return existed(items).map((type) => dispatch('getRelationships', {
    id,
    type,
  }))
}

export const getRelationshipsDispatches = (id, relationships, dispatch) => {
  return actions.reduce((acc, action) => {
    return [ ...acc, ...getDispatches(id, relationships, dispatch, action), ]
  }, [])
}

export const getEntityDispatches = (id, entity, dispatch) => {
  const actions = [
    {
      field: 'successorEntities',
      type: 'successor-entities',
    },
    {
      field: 'successorEntity',
      type: 'successor-entity',
    },
    {
      field: 'associatedEntity',
      type: 'associated-entity',
    },
  ]
  // TODO: update logic when successorEntity is removed from mock api
  const needHandle = (field) => !!entity[field].lei && !entity[field].name
  const needHandleArray = (field) => {
    if (entity[field]) {
      return entity[field].some((successor) => {
        return !!successor.lei && !successor.name
      })

    }
    return false
  }
  const filteredActions = actions.reduce((acc, { field, type, }) => {
    if (field === 'successorEntities') return needHandleArray(field) ? [ ...acc, type, ] : [ ...acc, ]
    if (field === 'successorEntity') {
      return needHandleArray('successorEntities') ? [ ...acc, ] : needHandle(field) ? [ ...acc, type, ] : [ ...acc, ]
    }
    return needHandle(field) ? [ ...acc, type, ] : [ ...acc, ]
  }, [])
  return filteredActions.map((type) => dispatch('getRelationships', {
    id,
    type,
  }))
}

export const getChildrenDispatches = (relationships, dispatch, id) => {
  const children = [ 'direct-children', 'ultimate-children', ]
  const getExisted = (field) => ({
    type: field,
    isExists: !!relationships[field],
  })
  return children.map((item) => dispatch('getChildren', {
    id,
    ...getExisted(item),
  }))
}

export const getISINDispatches = (state, dispatch, id, params) => {
  return dispatch('getISIN', {
    id,
    params,
  })
}

export const getSubInfo = (state, dispatch) => {
  const { registeredAt, legalForm, } = state.record.entity
  const { validatedAt, } = state.record.registration
  const ra = registeredAt ? registeredAt.id : null
  const elf = legalForm ? legalForm.id : null
  const rrRA = validatedAt ? validatedAt.id : null
  return [
    dispatch('getELF', elf),
    dispatch('getRA', ra),
    getOtherValidationAuthoritiesInfo(state, dispatch),
    dispatch('getRelationshipRA', {
      ra: rrRA,
      rr: 'ENTITY',
    }),
  ]
}

export const templateCriteriaModifications = (field = '', operator = '', value = '') => ({
  relationship: {
    label: '',
    id: 'MODIFICATION_HISTORY',
  },
  field,
  fields: [],
  operator: field && field.operators ? field.operators[0] : '',
  operators: field && field.operators ? field.operators : [],
  dataType: 'STRING',
  value,
})


const getOtherValidationAuthoritiesInfo = async (state, dispatch) => {
  const { otherValidationAuthorities, } = state.record.registration
  if (otherValidationAuthorities.length === 0) {
    return
  }
  const promises = otherValidationAuthorities.map((authority, index) => {
    return dispatch('getOVA', {
      code: authority.validatedAt.id,
      index: index,
    })
  })

  const results = await Promise.all(promises)
  return results

}



// WEBPACK FOOTER //
// ./src/store/modules/record/helpers/actions-helper.js